<template>
    <div>
        <div :class="['tab-desktop-' + desktop + ' tab-mobile-' + mobile]" >
            <CustomTab v-for="tab in tabs" :desktop="desktop" :mobile="mobile"
                       :key="tab.id" :tabId="tab.id"
                       v-on:clickTabEvent="output"
            />
        </div>
        <div :class="['tab-area-desktop-' + ' '  + ' tab-area-mobile-' + ' ' ]" >
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import CustomTab from "./CustomTab";

    export default {
        name: 'CustomTabs',
        components: {CustomTab},
        props: ['desktop', 'mobile', 'tabs', 'tabId'],
        data() {
          return {
              currentTab: '2'
          }
        },
        methods: {
            output: function(identifier) {
                this.currentTab = identifier;
            },
        },
        created() {

        }
    }
</script>

<style scoped>

    @media only screen and (max-width: 767px) {
        .tab-mobile-,
        .tab-mobile-default {
            position: fixed;
            bottom: 0;
            border-top: 1px solid gray;
            left: 0;
            height: 70px;
            overflow: auto;
            white-space: nowrap;
            width: 100%;
            z-index: 1000;
            background-color: #2E2D2D;
        }
    }
    @media only screen and (min-width: 768px) {
        .tab-desktop-,
        .tab-desktop-default {
            display: flex;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
            padding-left: 0;
            margin-bottom: 0;
            list-style: none;
            border-bottom: 0;
        }
    }

</style>